import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import GolfCourseIcon from '@mui/icons-material/GolfCourse'
import SportsCricketIcon from '@mui/icons-material/SportsCricket'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import GridViewIcon from '@mui/icons-material/GridView'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import FlightIcon from '@mui/icons-material/Flight'
import PaymentsIcon from '@mui/icons-material/Payments'
import SmartphoneIcon from '@mui/icons-material/Smartphone'
import { LiaHorseHeadSolid } from 'react-icons/lia'

import { IRaffleCategory } from 'types/prize-draw/raffles'

export const INSTANT_WINS_FILTER = 'instant-wins'
export const ALL_FILTER_ID = 0
export const ENDING_SOON_FILTER_ID = 'ending-soon'

export const ENDING_SOON_FILTER_ELEMENT = {
  id: ENDING_SOON_FILTER_ID,
  label: 'Ending Soon',
  icon: <AccessTimeIcon />,
}

export const FILTERING_MODULE_ELEMENTS = [
  {
    id: 0,
    label: 'All',
    icon: <GridViewIcon />,
  },
  {
    id: 2,
    label: 'Football',
    icon: <SportsSoccerIcon />,
  },
  {
    id: 3,
    label: 'Golf',
    icon: <GolfCourseIcon />,
  },
  {
    id: 4,
    label: 'Holidays',
    icon: <BeachAccessIcon />,
  },
  {
    id: 5,
    label: 'Cricket',
    icon: <SportsCricketIcon />,
  },
  {
    id: 6,
    label: 'Horse Racing',
    // @ts-expect-error - ReactNode is not recognized as a valid JSX element in the current TypeScript/@types/react version
    icon: <LiaHorseHeadSolid />,
  },
  {
    id: 7,
    label: 'Multiple Sports',
    icon: <EmojiEventsIcon />,
  },
]

export const mapCategoryToIcon = ({ id, name, image_url }: IRaffleCategory) => {
  switch (name) {
    case 'Football':
      return {
        id,
        label: name,
        icon: <SportsSoccerIcon />,
      }
    case 'Golf':
      return {
        id,
        label: name,
        icon: <GolfCourseIcon />,
      }
    case 'Holidays':
    case 'Holiday':
      return {
        id,
        label: name,
        icon: <BeachAccessIcon />,
      }
    case 'Cricket':
      return {
        id,
        label: name,
        icon: <SportsCricketIcon />,
      }
    case 'Horse Racing':
      return {
        id,
        label: name,
        // @ts-expect-error - ReactNode is not recognized as a valid JSX element in the current TypeScript/@types/react version
        icon: <LiaHorseHeadSolid />,
      }
    case 'Multiple Sports':
      return {
        id,
        label: name,
        icon: <EmojiEventsIcon />,
      }
    case 'Sports':
      return {
        id,
        label: name,
        icon: <EmojiEventsIcon />,
      }
    case 'Travel':
      return {
        id,
        label: name,
        icon: <FlightIcon />,
      }
    case 'Cash':
      return {
        id,
        label: name,
        icon: <PaymentsIcon />,
      }
    case 'Tech':
      return {
        id,
        label: name,
        icon: <SmartphoneIcon />,
      }
    default:
      return {
        id,
        label: name,
        icon: null,
        imageSrc: image_url,
      }
  }
}
